import BaseModule from "~/vuex/modules/base-module";

let EnquiryNotes = {...BaseModule};

EnquiryNotes.state = function () {
    let state = BaseModule.state();

    state.lastDate = null;
    state.sort = {};

    return state;
};

export default EnquiryNotes;
